export const resources = {
  icons: {
    INSTITUTIONS:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627957/Interswitch/ITG/icons/institution_xp1fmn.svg",
    CONFIGURATION:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627954/Interswitch/ITG/icons/configuration_fstjff.svg",
    CHECK_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/icons/check-solid_la0fnt.svg",
    TIMES_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627961/Interswitch/ITG/icons/times-solid_fyqthh.svg",
    INFO_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627957/Interswitch/ITG/icons/info-solid_a5vykf.svg",
    EYE_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627958/Interswitch/ITG/icons/eye-solid_tn90np.svg",
    EYE_SLASH_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627955/Interswitch/ITG/icons/eye-slash-solid_viv20t.svg",
    CLIPBOARD_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/icons/clipboard-solid_m05gc4.svg",
    CREDIT_CARD:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627955/Interswitch/ITG/icons/credit-card_oyuulr.svg",
    CERTIFICATE_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/icons/certificate-solid_fpfn4b.svg",
    INFO_CIRCLE_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627947896/Interswitch/ITG/icons/info-circle-solid_v3890g.svg",
    ARROW_LEFT_SOLID:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627947896/Interswitch/ITG/icons/arrow-left-solid_wlil7o.svg",
    ISSUER_PROFILE:
      "https://res.cloudinary.com/jaycodist/image/upload/v1628244678/Interswitch/ITG/icons/issuer-single_hcjnmf.svg",
    COLOR_CANCEL:
      "https://res.cloudinary.com/jaycodist/image/upload/v1628587871/Interswitch/ITG/icons/color-cancel_dkw1ft.svg",
    CLEAR:
      "https://res.cloudinary.com/jaycodist/image/upload/v1629363260/Interswitch/ITG/icons/delete-icon-gray_de9imh.svg",
    SEARCH:
      "https://res.cloudinary.com/jaycodist/image/upload/v1629363260/Interswitch/ITG/icons/search-icon_ahk5po.svg"
  },
  images: {
    LOADING_WHITE:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/images/loading-icon-white_dwz8su.svg",
    ANIMATION_IMG:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/images/animation-img_eesphu.svg",
    ANIMATION_IMG_SPIN:
      "https://res.cloudinary.com/jaycodist/image/upload/v1627627952/Interswitch/ITG/images/animation-img-spin_iyx9si.svg"
  }
};

const cache = [];

const preloadImages = (images: string[]) => {
  images.forEach(image => {
    const img = new Image();
    img.src = image;
    cache.push(img);
  });
};

preloadImages(Object.values(resources.icons));
preloadImages(Object.values(resources.images));
